export const APP = 'DEVICE_DETAILS' as const;

// Legacy constants which are still used as storage keys
export const CONTAINER_TARIFF = 'TARIFF';
export const CONTAINER_TRADEIN = 'TRADEIN';
export const CONTAINER_HARDWARE_ONLY = 'HARDWARE_ONLY';

// #region HTML IDs

export const HTML_CONTAINER_ID_PREFIX = 'device-details' as const;

export const ERROR_NOTIFICATION_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-error-notification` as const;
export const TEXT_HEADER_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-text-header` as const;
export const IMAGE_GALLERY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-image-gallery` as const;
export const OPTION_PICKER_COLOR_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-option-picker-color` as const;
export const OPTION_PICKER_CAPACITY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-option-picker-capacity` as const;
export const DELIVERY_DATE_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-delivery-date` as const;
export const HARDWARE_ONLY_SWITCH_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-hardware-only-switch` as const;
export const PROMOS_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-promos` as const;
export const OFFER_SUMMARY_CARD_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-offer-summary-card` as const;
export const STICKY_PRICE_BAR_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-sticky-price-bar` as const;
export const TECHNICAL_DETAILS_ACCORDION_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-technical-details-accordion` as const;
export const TRADEIN_PROMO_ICON_TEXT_LIST_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-promo-overview-icon-text-list` as const;
export const OVERLAY_CONTAINER_ID = `${HTML_CONTAINER_ID_PREFIX}-overlay` as const;

// #endregion

// #region TradeIn HTML IDs

const TRADEIN_HTML_CONTAINER_ID_PREFIX = `${HTML_CONTAINER_ID_PREFIX}-tradein`;
const TAUSCHBONUS_HTML_CONTAINER_ID_PREFIX = `${HTML_CONTAINER_ID_PREFIX}-tauschbonus`;

export const TRADEIN_HEADLINE_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-headline`;
export const TRADEIN_OPTION_PICKER_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-option-picker`;
export const TRADEIN_INFO_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-info`;
export const TAUSCHBONUS_INFO_CONTAINER_ID = `${TAUSCHBONUS_HTML_CONTAINER_ID_PREFIX}-info`;
export const TRADEIN_ITEM_SUMMARY_CARD_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-item-summary-card`;
export const TRADEIN_SUGGEST_INPUT_HEADLINE_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-suggest-input-headline`;
export const TRADEIN_SUGGEST_INPUT_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-suggest-input`;
export const TRADEIN_STATUS_NOTIFICATION_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-status-notification`;
export const TRADEIN_HARDWARE_ONLY_NOTIFICATION_CONTAINER_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-hardware-only-notification`;
export const TRADEIN_INPUT_ID = `${TRADEIN_HTML_CONTAINER_ID_PREFIX}-input`;
export const TAUSCHBONUS_PROMOTIONAL_CARD_CONTAINER_ID = `${TAUSCHBONUS_HTML_CONTAINER_ID_PREFIX}-promotional-card`;
export const TAUSCHBONUS_ICON_TEXT_SUBLINE_ID = `${TAUSCHBONUS_HTML_CONTAINER_ID_PREFIX}-icon-text-subline`;

// #endregion

// #region Misc

export const DEEPLINK_SESSION_STORAGE_KEY = 'deeplink' as const;
export const GIGAKOMBI_TOKEN_PARAM = 'token' as const;
export const GIGAKOMBI_OVERLAY_NAME = 'gigakombi-login-overlay' as const;
export const GIGAKOMBI_OVERLAY_GIGAKOMBI_BUTTON_ID = 'overlay-button-basket-gigakombi' as const;
export const GIGAKOMBI_OVERLAY_NO_GIGAKOMBI_BUTTON_ID = 'overlay-button-basket' as const;

// #endregion
